export default __webpack_public_path__ + "static/media/photo-booth-bg.19f2ba38.png";